import Container from '@/containers';

const projectRouter = {
    path: '/project',
    component: Container, 
    name: 'project',
    meta: {
        title: '产品介绍'
    },
    children: [
        {
            path: '/project',
            component: () => import('@/views/project'),
            name: 'project',
            meta: {
                title: '产品介绍'
            }
        }
    ]
};

export default projectRouter;